import { z } from "zod";

import { DatabaseIdentity, DatabaseSystemRecord } from "@/core/api";
import { DateIsoString } from "@/core/types";

import { AssignmentOrigin } from "./AssignmentOrigin";

export const AssignmentShort = z
  .object({
    startDate: DateIsoString,
    endDate: DateIsoString,
    status: z.string(),

    version: z.number(),

    origin: AssignmentOrigin,
  })
  .merge(DatabaseIdentity)
  .merge(DatabaseSystemRecord);

export type AssignmentShort = z.infer<typeof AssignmentShort>;
